import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import React from "react";
import {CatalogueItem} from "./CatalogueItem";

interface CatalogueItemsInterface {
    catalogue: any[],
    max?: number,
    showTFCatalog: boolean,
}

export const CatalogueItems = ({catalogue, max, showTFCatalog}: CatalogueItemsInterface) => {
    if (max === undefined) {
        max = catalogue.length;
    }

    return (
        <>
            <Col lg={12} sm={12} xs={12}>
                <Row xs={1} md={2} lg={3} className="g-4">
                    {catalogue.slice(0, max).map((product, i) => (
                        <>
                            <CatalogueItem product={product} index={i} show={showTFCatalog || product.nomcat !== 'TF'}/>
                        </>
                    ))}
                </Row>
            </Col>
        </>
    );
}